<template>
  <q-page style="">
        <div class="row justify-center" style="margin: auto; height: calc(100vh - 128px);">
            <div class="col-12 col-md-9 q-pa-lg" style="height: 100%;">
                <q-card  style="border-radius: 1rem !important; box-shadow: none !important; height: 100%; background: #fff; position: relative; width: 100%;"> 
                    <q-card-section style=" margin: 0;position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%); width: 100%;">
                    <div class="row justify-center q-pa-md" style="margin-top: auto; margin-bottom: auto;">
                        <div class="col-xs-12 col-sm-5 col-md-6 col-lg-5 q-py-md q-px-sm text-center">
                            <img  src="@/assets/maintenance.png" style="height: auto; width: 100%; max-height: 450px !important;" >
                        </div>
                        <div class="col-xs-12 col-sm-7 col-md-6 col-lg-5 q-py-md q-px-sm" style="padding-left:20px">
                            <div class="text-bold q-mb-xs" style="font-size: 24px !important;">We're Sorry! </div>
                            
                            <div class="text-bold q-mb-sm" style="font-size: 16px !important;">The portal will be temporarily unavailable for maintenance on the following dates:
                             </div>
                                <div>
                                Saturday, 20 June 2020 (9.00am-11.00pm)<br>
                                Sunday, 21 June 2020 (10.00am-11.00pm)<br>
                                
                            </div>
                            <!-- <div >We thank you for your patience and understanding.</div> -->
                            <br>
                            <q-btn unelevated style="background: #ff6666; color: white; border-radius: 0.5rem;"  label="Contact Us" @click="reroute()" ></q-btn>
                        </div>
                    </div>
                    </q-card-section>
                </q-card>
            </div>
        </div>
  </q-page>
</template>

<script>
export default {
      data() {},  
    methods:{

    },mounted(){
        this.$q.loading.hide()
         }
 
}
</script>